export default __webpack_public_path__ + "static/media/img-slider-siamblockchain-2.9f69cc66.png";